import { useParams } from "react-router-dom";
import Breadcrumbs from "../../common2/Breadcrumbs";
import AzureUserFormPage from "./AzureUserFormPage";

const AddEditAzureUser = () => {
  const param: any = useParams();
  const isEdit = Boolean(param.id);

  return (
    <>
      <Breadcrumbs
        data={[
          {
            title: "Contact Management ",
            path: "/ContactManagement",
          },
          {
            title: "Azure Users ",
            path: "/AzureManagement/AzureUsers",
          },
          {
            title: isEdit ? "Edit Azure User" : "Add Azure User",
            path: isEdit
              ? `/AzureManagement/AzureUsers/edit/${param.id}`
              : "/AzureManagement/AzureUsers/add",
          },
        ]}
      />

      <AzureUserFormPage isEdit={isEdit} userId={param.id || null} />
    </>
  );
};

export default AddEditAzureUser;